@if (formAvInvestmentTypeValue !== 'INITIAL') {
  <div class="row">
    <div class="col-md-12">
      <pr-input-radio
        [derrors]="derrors"
        formControlName="avProgammedPaymentType"
        direction="column"
        [isDefault]="false"
        columns="2"
        [options]="avProgammedPaymentTypeOptions"
        label="Fréquence de versements"
      >
      </pr-input-radio>
    </div>
  </div>
}

@if (
  formAvInvestmentTypeValue == 'INITIAL' ||
  formAvInvestmentTypeValue == 'INITIAL_AND_MONTHLY' ||
  (formAvInvestmentTypeValue == 'MONTHLY' &&
    form.get('lifeInsuranceMinInitialPayment')?.value > 0)
) {
  <pr-input-column
    label="Versement initial"
    [derrors]="derrors"
    [isDefault]="false"
    [readonly]="formAvInvestmentTypeValue == 'MONTHLY'"
  >
    <img
      src="assets/svg/ressources/money1.svg"
      style="width: 34px; height: 34px; margin-right: 24px"
    />
    <input
      notdot
      matInput
      placeholder="Exemple : 8 000 €"
      formControlName="avInitialPayment"
      type="text"
      [readonly]="formAvInvestmentTypeValue == 'MONTHLY'"
    />
    <i>€</i>
  </pr-input-column>
}

<pr-input-column
  label="Versement programmés "
  [derrors]="derrors"
  [isDefault]="false"
  [hidden]="formAvInvestmentTypeValue == 'INITIAL'"
>
  <img
    src="assets/svg/ressources/cashback1.svg"
    style="width: 34px; height: 34px; margin-right: 24px"
  />
  <input
    [required]="formAvInvestmentTypeValue !== 'INITIAL'"
    notdot
    matInput
    [placeholder]="
      formAvProgammedPaymentTypeValue == 'MONTHLY'
        ? 'Exemple : 200 € / mois'
        : 'Exemple : 200€ / trimestre'
    "
    formControlName="avMonthlyPayment"
    type="text"
  />
  <i>
    {{
      formAvProgammedPaymentTypeValue == 'MONTHLY' ? ' €/mois' : '€/trimestre'
    }}
  </i>
</pr-input-column>
@if (form.get('lifeInsuranceMinInitialPayment')?.value > 0) {
  <info [option]="{ icon: 'info' }">
    Pour un versement initial, il sera nécessaire d'effectuer un versement de
    {{ form.get('lifeInsuranceMinInitialPayment')?.value }}
    € minimum.
  </info>
}
